import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { useThunk } from "../../hooks/useThunk";
import { fetchUserNotifications, setSelectedFormType } from "../../store";
import Traingle from "./../../assets/Notification/notificationDropdownTraingle.svg"
import NotificationIcon from "./../../assets/Notification/NotificationIcon.svg"
import NoNotifications from "./../../assets/Notification/NoNotifications.svg"
import showToast from "../../utils/toastNotifications";
import { useDispatch } from "react-redux";
import { systemNotifications } from "../../constants/commonConstants";

const Notifications = () => {

    const navigate = useNavigate();
	const dispatch = useDispatch()


    const [notifications, setNotifications] = useState([])
    const [notificationAmount, setNotificationAmount] = useState()
    const [notificationPage, setNotificationPage] = useState(1);
    const [MessageNotificationPage, setMessageNotificationPage] = useState(1);
    const [messageNotifications, setMessageNotifications] = useState([])
    const [messageNotificationAmount, setMessageNotificationAmount] = useState()


    const [isOpen, setIsOpen] = useState(false)
    const [isOpenMessage, setIsOpenMessage] = useState(false)
    const popUpRef = useRef(null)
    const size = 10;
    // const popUpRefMessage = useRef(null)

    const [doFetchUserNotifications, isNotificationsLoding, ErrorFetchingNotifications] = useThunk(fetchUserNotifications)
    const isMessageNotificationsLoding = false;

    const currentTime = new Date();

    const pendingPaymentMessages = new Set([
        systemNotifications.PENDING_PAYMENT,
        "Your order is waiting for your payment. Please complete the payment to proceed.",
        "Your order is pending payment. Please complete the payment to proceed.",
        "Your order has been created. Please complete payment to continue.",
    ]);

    const getNotificationContent = (content) => {
        if (pendingPaymentMessages.has(content)) {
            return systemNotifications.PENDING_PAYMENT;
        }

        return content;
    };

    const handlePendingPaymentClick = (item, event) => {
        event.stopPropagation();
        dispatch(setSelectedFormType("pay-now"));
        navigate(`/thread?roomIdParam=ID${item.roomId}&threadIdParam=${item._id}`);
        setIsOpen(false);
        setIsOpenMessage(false);
    };

    const status = {
				REQUIREMENTS_SUBMITTED: "#DA1A28",
				PENDING_PAYMENT: "#DA1A28",
				ORDER_IN_PROGRESS: "#06BCCC",
				PENDING_WRITER: "#06BCCC",
        ORDER_DELIVERED: "#0020BD",
        IN_REVISION: "#DA1A28",
        COMPLETED: "#83899F",
				COMPLAINT_RAISED: "#DA1A28",
				RESOLVED: "#83899F",
				CANCELLED: "#DA1A28"
    }

    useEffect(() => {
        const fetchThreads = async () => {
            const result = await doFetchUserNotifications({ page: notificationPage, size: size })
            if (result.success) {
								const data = result.response.data[0].data
								const updatedResult = data.map((item, index, arr) => {
									
									const messageDate = new Date(item.lastUnreadNotification?.createdAt);
									const diffMs = Math.max(0, currentTime - messageDate)
									const diffMins = Math.floor(diffMs / (1000 * 60));
									const diffHours = Math.floor(diffMins / 60);
									
									const isSameDay = currentTime.toDateString() === messageDate.toDateString();
									const prevItemIsSameDay = currentTime.toDateString() === new Date(arr[index-1]?.lastUnreadNotification?.createdAt)?.toDateString()
									
									if(!isSameDay && prevItemIsSameDay){
									item.olderFlag = true
									}
									if(notificationPage === 1 && index === 0 && isSameDay){
										item.todayFlag = true
									}

								item.timeDiffDisplay = `${diffHours >= 24 ? `${(diffHours / 24) | 0}d` : diffHours >= 1 ? `${diffHours}h` : `${diffMins}m`} ago`;
								item.statuscolour = status[item.orderStatus]
								item.roomId = item.roomId.replace("ID","")
								return item
								})
                setNotifications((prev) => [...prev, ...updatedResult]);
								if(notificationPage === 1){
									setNotificationAmount(result.response.data[0].totalDocuments);
								}
            }else{
							showToast("error", "Error Fetching notifications")
						}
        }
        fetchThreads()
    }, [notificationPage])

    const handleNotificationLoad = () => {
        setNotificationPage((prev) => prev + 1);
        console.log(notificationPage);
    }

    const handleMessageNotificationLoad = () => {
        setMessageNotificationPage((prev) => prev + 1);
        console.log(MessageNotificationPage);
    }

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popUpRef.current && !popUpRef.current.contains(event.target)) {
                setIsOpen(false);
                setIsOpenMessage(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (
			<>
				<div className="relative flex cursor-pointer mr-2 min-w-[30px]" title="Notifications" ref={popUpRef}>
						<div className="absolute text-[0.8rem] top-0 right-0 flex justify-center items-center rounded-full px-1 min-w-[20px] text-white font-bold bg-[#DA1E28]">
								{!isNotificationsLoding && !ErrorFetchingNotifications && notificationAmount > 10 ? "9+" : notificationAmount > 0 ? notificationAmount : ""}
						</div>
						{(isOpen || isOpenMessage) &&
							<>
								<div className={` absolute top-[100%] ${isOpen ? "left-2.5" : ""} ${isOpenMessage ? "left-[3.7rem]" : ""} `}><img src={Traingle} /></div>
								<div className={` absolute sm:max-w-[320px] w-[320px]  max-w-[300px]  max-h-[502px] md:max-h-[502px] mx-1 top-[130%] ${isOpen ? "xs:-right-[80%] -right-12 xs:-right-8" : ""} ${isOpenMessage ? "md:-right-[130%] -right-12 xs:-right-8" : ""}  border-[1px] border-[#DFDFDF] bg-[#FFFFFF] shadow-lg rounded-[20px] `}>
									<div className="flex h-[52px]  border-b border-[#E6E9FC99] text-base font-semibold justify-center items-center font-[#2F3464]">
										{isOpen ?
											<span>Your Notifications  </span>
											:
											<span>Your Messages  </span>
										}
									</div>
											<div className="max-h-[450px] min-h-[450px] overflow-y-auto ">
												{(isOpen && notifications.length > 0) || (isOpenMessage && messageNotifications.length > 0) ? (
													isOpen ? (
														<>
															{notifications.map((item) => {
																return (
																	<>
																		{(item.todayFlag || item.olderFlag) && 
																		<div
																			className="flex w-full max-w-[320px] h-[40px] border-b border-[#E6E9FC99] px-2 sm:px-3 py-1 hover:bg-[#0061FE14] justify-between">
																				<span className="text-[#000000] font-bold">{item.todayFlag ? "Today" : "Older"}</span>
																		</div>}
																		<div
																			className="flex w-full max-w-[320px] h-[90px] border-b border-[#E6E9FC99] px-2 sm:px-3 py-1 hover:bg-[#0061FE14] justify-between"
																				onClick={() => { 
																					
																					navigate(`/thread?roomIdParam=ID${item.roomId}&threadIdParam=${item._id}`); 
																					dispatch(setSelectedFormType("system"))
																					}}>
																				<div className=" flex flex-col max-w-[250px] justify-center">
																					<span className="text-sm font-inter font-medium text-[#0020BD] pb-1">Order ID:{item.roomId}</span>
																					<div className="w-[250px] text-sm font-inter text-[#1E1919] font-normal line-clamp-2">
																						<span>{getNotificationContent(item.lastUnreadNotification?.content)}</span>
																						{pendingPaymentMessages.has(item.lastUnreadNotification?.content) && (
																							<button
																								type="button"
																								onClick={(event) => handlePendingPaymentClick(item, event)}
																								className="ml-1 font-medium text-blue-shades underline underline-offset-2"
																							>
																								Pay Now
																							</button>
																						)}
																					</div>
																				</div>
																				<div className="max-w-[50px] flex flex-col">
																					<div className="h-full flex items-center">
																							<div className={` min-h-2 max-h-2 min-w-2 max-w-2 bg-[${item.statuscolour}] rounded-full`}></div>
																					</div>
																					<div className=" h-full flex font-inter text-xs font-normal text-[#524A3ED1] justify-center items-center">
																							{item.timeDiffDisplay}
																					</div>
																				</div>
																		</div>
																	</>
																)})}
																{notificationAmount > notificationPage * size && (
																	<div className="flex justify-center pt-3 pb-3">
																			<button
																				disabled={isNotificationsLoding}
																				onClick={handleNotificationLoad} 
																				className="w-[100px] text-blue-shades font-semi-bold bg-light-blue disabled:opacity-80">
																						Load more
																			</button>
																	</div>
																)
																}
														</>
															)
															:
															(
																<div>
																	{messageNotifications.map((item) => {
																		return (
																		<>
																			{(item.todayFlag || item.olderFlag) && 
																				<div
																					className="flex w-full max-w-[320px] h-[40px] border-b border-[#E6E9FC99] px-2 sm:px-3 py-1 hover:bg-[#0061FE14] justify-between">
																						<span className="text-[#000000] font-bold">{item.todayFlag ? "Today" : "Older"}</span>
																				</div>}
																			<div
																				className="flex w-full max-w-[320px] h-[90px] border-b border-[#E6E9FC99] px-2 sm:px-3 py-1 hover:bg-[#0061FE14] justify-between"
																					onClick={() => { navigate(`/thread?roomIdParam=ID${item.roomId}&threadIdParam=${item._id}`); }}>
																					<div className=" flex flex-col max-w-[250px] justify-center">
																						<span className="text-sm font-inter font-medium text-[#0020BD] pb-1">Order ID:{item.roomId}</span>
																						<span className=" w-[250px]  text-sm font-inter text-[#1E1919]  font-normal line-clamp-2">{item.lastMessage?.content}</span>
																					</div>
																					<div className="max-w-[50px] flex flex-col">
																						<div className="h-full flex items-center">
																								<div className={` min-h-2 max-h-2 min-w-2 max-w-2 bg-[${item.statuscolour}] rounded-full`}></div>
																						</div>
																						<div className=" h-full flex font-inter text-xs font-normal text-[#524A3ED1] justify-center items-center">
																								{item.timeDiffDisplay}
																						</div>
																					</div>
																			</div>
																		</>
																			);
																	})
																	}
																		{messageNotificationAmount > MessageNotificationPage * size && (
																			<div className="flex justify-center pt-3 pb-3 ">
																				<button
																					onClick={handleMessageNotificationLoad} 
																					disabled={isMessageNotificationsLoding}
																					className="w-[100px] text-blue-shades font-semi-bold bg-light-blue disabled:opacity-80">
																						Load more
																				</button>
																			</div>
																		)}
																</div>														
														)
													)
													:
													(
														<div className="max-h-[450px] h-[450px] flex flex-col pb-40 justify-center items-center overflow-auto ">
															<div>
																<img src={NoNotifications} />
															</div>
															<div>
																<span>{isOpen ? "You don't have any notifications" : "You don't have any messages"}</span>
															</div>
														</div>
													)
													}
											</div>
									</div>
							</>
						}
						<div className="flex items-center justify-center w-[48px] h-[48px]" onClick={() => { setIsOpen(prev => !prev); setIsOpenMessage(false); }} >
								<img src={NotificationIcon} alt="Notifications" />
						</div>
				</div >
			</>
    );
};

export default Notifications;
